/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */

// State
import { TStore } from '@store/index';
import { StateCreator } from 'zustand';
import { CRYPTO_SECRET_PASSPHRASE } from '@config/constants/env';
import {
	decryptFromStorage,
	encryptAndStore,
} from '@utils/crypto';
import { TUser } from '@global-types/api/api';

/* -------------------------------------------------------------------------- */
/*                                  Interface                                 */
/* -------------------------------------------------------------------------- */
export interface IAuthSlice {
	authForm: string;
	user: Partial<TUser>;
	setUser: (_user: TUser) => void;
	getUser: () => TUser | boolean;
	isShowModalEmailSent: boolean;
	setAuthForm: (_authForm: string) => void;
	setIsShowModalEmailSent: (
		_isShowModalEmailSent: boolean
	) => void;
}

/* -------------------------------------------------------------------------- */
/*                                    Slice                                   */
/* -------------------------------------------------------------------------- */

const initialState = {
	authForm: 'signin',
	isShowModalEmailSent: false,
	user: {},
};

export const createAuthSlice: StateCreator<
	TStore,
	[],
	[],
	IAuthSlice
> = (set) => ({
	...initialState,
	setIsShowModalEmailSent: (
		_isShowModalEmailSent: boolean
	) =>
		set({ isShowModalEmailSent: _isShowModalEmailSent }),
	setAuthForm: (_authForm: string) =>
		set({ authForm: _authForm }),

	setUser: (_user: TUser) => {
		set({ user: _user });
		encryptAndStore(
			JSON.stringify(_user),
			CRYPTO_SECRET_PASSPHRASE,
			'user'
		);
	},
	getUser: () => {
		const userDecrypted = decryptFromStorage(
			'user',
			CRYPTO_SECRET_PASSPHRASE
		);
		if (userDecrypted) {
			return JSON.parse(String(userDecrypted));
		} else {
			return false;
		}
	},
});
